// extracted by mini-css-extract-plugin
export var lightBg = "styles-module--lightBg--3hyKk";
export var titleContainer = "styles-module--titleContainer--3Bz10";
export var container = "styles-module--container--1JaXu";
export var imageEffectContainer = "styles-module--imageEffectContainer--3RN8_";
export var ctaRow = "styles-module--ctaRow--2Daq6";
export var arrowRight = "styles-module--arrowRight--AHe4D";